import searchIcon from '../../assets/imgs/icons/search.svg'
import { searchStateData } from '../../data/searchStateData'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { searchDataUpdated, setQuickSearchSelectionActive, setShowQuickSearchMobile } from '../../redux/reducers/searchSlice'
import { instructorSearchConnector } from '../../server/connector/InstructorSearchConnector'
import CtaButton from '../ctaButton/CtaButton'
import QuickSearchOption from './quickSearchOption/QuickSearchOption'
import './style.scss'

function QuickSearch() {
	const quickSearchSelectionActive = useAppSelector(state => state.search.quickSearchSelectionActive)
	// const quickSearchValuesSet = useAppSelector(state => state.search.quickSearchValuesSet)

	const dispatch = useAppDispatch()

	const quickSearchButtonClickHandler = () => {
		// console.log('Quick search button click handler')
		dispatch(setQuickSearchSelectionActive(false))
		dispatch(setShowQuickSearchMobile(false))
		searchStateData.clearExistingProfiles()
		instructorSearchConnector.performSearchRequest().then((successRequest) => {
			dispatch(searchDataUpdated())
			if (!successRequest) {
				console.log('WARNING - [App] - performSearchRequest() failed')
			}
		})
	}

	const clearSearchButtonClickHandler = () => {
		dispatch(setQuickSearchSelectionActive(false))
		dispatch(setShowQuickSearchMobile(false))
		searchStateData.clearExistingProfiles()
		searchStateData.clearAllQuickSearchOptions()
		instructorSearchConnector.performSearchRequest().then((successRequest) => {
			dispatch(searchDataUpdated())
			if (!successRequest) {
				console.log('WARNING - [App] - performSearchRequest() failed')
			}
		})
	}

	return (
		<div className={`quick-search-wrap ${quickSearchSelectionActive ? 'active' : ''}`}>
			{searchStateData.quickSearchOptions.map((_, index) => 
				<QuickSearchOption 
					index={index}
					key={`quickSearchOption${index}`}
				/>
			)}
			<div className='quick-search-button-wrap'>
				<CtaButton 
					label='Clear'
					size='small'
					// disabled={!quickSearchValuesSet}
					onClick={() => { clearSearchButtonClickHandler() }}
				/>
				<CtaButton 
					label='Search'
					icon={searchIcon}
					size='small'
					// disabled={!quickSearchValuesSet}
					onClick={() => { quickSearchButtonClickHandler() }}
				/>
			</div>
		</div>
	)
}

export default QuickSearch
